const numberToCpf = (n: string) => n.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
const numberToCpfHidden = (n: string) => n.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.***.$3-**')
const numberToCnpj = (n: string) =>
  n.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
const numberToCnpjHidden = (n: string) =>
  n.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.***.$3/$4-**')
const cpfToNumber = (n: string) => n.replace(/[^\w\s]/gi, '')
const toMoney = (n: string) => {
  return parseFloat(n).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 3,
    style: 'currency',
    currency: 'BRL',
  })
}
const toMoneyCent = (n: string) => {
  return (parseFloat(n) / 100).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 3,
    style: 'currency',
    currency: 'BRL',
  })
}

const toDate = (d: string) => {
  let firstSplit
  let day
  let mounth
  let year
  if (d && d.length > 0) {
    if (String(d).split('').includes('T')) {
      firstSplit = d.split('T')[0]
      day = firstSplit.split('-')[2]
      mounth = firstSplit.split('-')[1]
      year = firstSplit.split('-')[0]
    } else {
      firstSplit = String(d).split(' ')[0]
      day = firstSplit.split('-')[2]
      mounth = firstSplit.split('-')[1]
      year = firstSplit.split('-')[0]
    }
    return `${day}/${mounth}/${year}`
  }
  return '-'
}
const toHour = (d: string) => {
  let secondSplit
  let thirdSplit
  let hour
  let minute
  let second
  if (d && d.length > 0) {
    if (String(d).split('').includes('T')) {
      secondSplit = d.split('T')[1]
      thirdSplit = secondSplit.split('.')[0]
      hour = thirdSplit.split(':')[0]
      minute = thirdSplit.split(':')[1]
      second = thirdSplit.split(':')[2]
    } else {
      secondSplit = String(d).split(' ')[1]
      thirdSplit = secondSplit.split('.')[0]
      hour = thirdSplit.split(':')[0]
      minute = thirdSplit.split(':')[1]
      second = thirdSplit.split(':')[2]
    }
    return `${hour}:${minute}:${second}`
  }
  return ''
}
const toDateTime = (d: string) => {
  let firstSplit
  let secondSplit
  let thirdSplit
  let day
  let mounth
  let year
  let hour
  let minute
  let second
  if (d && d.length > 0) {
    if (String(d).split('').includes('T')) {
      firstSplit = d.split('T')[0]
      secondSplit = d.split('T')[1]
      thirdSplit = secondSplit.split('.')[0]
      day = firstSplit.split('-')[2]
      mounth = firstSplit.split('-')[1]
      year = firstSplit.split('-')[0]
      hour = thirdSplit.split(':')[0]
      minute = thirdSplit.split(':')[1]
      second = thirdSplit.split(':')[2]
    } else {
      firstSplit = String(d).split(' ')[0]
      secondSplit = String(d).split(' ')[1]
      thirdSplit = secondSplit.split('.')[0]
      day = firstSplit.split('-')[2]
      mounth = firstSplit.split('-')[1]
      year = firstSplit.split('-')[0]
      hour = thirdSplit.split(':')[0]
      minute = thirdSplit.split(':')[1]
      second = thirdSplit.split(':')[2]
    }
    return `${day}/${mounth}/${year} ${hour}:${minute}:${second}`
  }
  return ''
}
const toDateUS = (d: string) => {
  const firstSplit = d.split(' ')[0]
  const day = firstSplit.split('-')[2]
  const mounth = firstSplit.split('-')[1]
  const year = firstSplit.split('-')[0]
  return `${year}-${mounth}-${day}`
}

const dateBRtoDateUS = (d: string) => {
  const day = d.split('/')[0]
  const mounth = d.split('/')[1]
  const year = d.split('/')[2]
  return `${year}-${mounth}-${day}`
}

const toTimeStamp = (d: string) => {
  let day = ''
  let mounth = ''
  let year = ''
  if (d.includes('/')) {
    day = d.split('/')[0]
    mounth = d.split('/')[1]
    year = d.split('/')[2]
  } else {
    day = d.split('-')[0]
    mounth = d.split('-')[1]
    year = d.split('-')[2]
  }
  return `${year}-${mounth}-${day}`
}

const formatPhone = (value: string) => {
  value = value.replace(/\D/g, '') //Remove tudo o que não é dígito
  value = value.replace(/^(\d{2})(\d)/g, '($1) $2') //Coloca parênteses em volta dos dois primeiros dígitos
  value = value.replace(/(\d)(\d{4})$/, '$1-$2') //Coloca hífen entre o quarto e o quinto dígitos
  return value
}

export function telephoneNoMask(telephone: string) {
  let newTelephone = telephone.replaceAll('(', '')
  newTelephone = newTelephone.replaceAll(')', '')
  newTelephone = newTelephone.replaceAll(' ', '')
  newTelephone = newTelephone.replaceAll('-', '')
  return newTelephone
}

export function secondsToHour(seconds: number) {
  const hours = seconds / 3600
  const hoursToUse = Math.trunc(hours)
  const minutes = (hours - hoursToUse) * 60
  const minutesToUse = Math.trunc(minutes)
  const secondsToUse = (minutes - minutesToUse) * 60
  return `${hoursToUse > 9 ? hoursToUse : `0${hoursToUse}`}:${
    minutesToUse > 9 ? minutesToUse : `0${minutesToUse}`
  }:${Math.trunc(secondsToUse) > 9 ? Math.trunc(secondsToUse) : `0${Math.trunc(secondsToUse)}`}`
}

export function timeStamptoBr(date: string) {
  return new Date(date).toLocaleString('pt-BR', {
    timeZone: 'America/Sao_Paulo', // Define o fuso horário do Brasil
    weekday: 'long', // Mostra o dia da semana
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
}

const formatCpfCnpj = (cpfCnpj: string) => {
  let newCpf = cpfCnpj.replaceAll('.', '')
  newCpf = newCpf.replaceAll('-', '')
  newCpf = newCpf.replaceAll('/', '')
  return newCpf
}

function removeEspacosEmBranco(str: string): string {
  return str.trim()
}

function rtcToText(content: string) {
  let contentFormated = content.replace(/\\par[d]?/g, '<br>')
  contentFormated = contentFormated.replace(/\n([0-9]*)?/g, '<br>')
  contentFormated = contentFormated.replace(/\\bullet\\tab/gi, '&nbsp;-')
  contentFormated = contentFormated
    .replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, '')
    .trim()

  contentFormated = contentFormated.replace(/\\'e3/g, 'ã')
  contentFormated = contentFormated.replace(/\\'c3/g, 'Ã')
  contentFormated = contentFormated.replace(/\\'e1/g, 'á')
  contentFormated = contentFormated.replace(/\\'c1/g, 'Á')

  contentFormated = contentFormated.replace(/\\'ea/g, 'ê')
  contentFormated = contentFormated.replace(/\\'ca/g, 'Ê')
  contentFormated = contentFormated.replace(/\\'e9/g, 'é')
  contentFormated = contentFormated.replace(/\\'c9/g, 'É')

  contentFormated = contentFormated.replace(/\\'ed/g, 'í')

  contentFormated = contentFormated.replace(/\\'f3/g, 'ó')
  contentFormated = contentFormated.replace(/\\'f5/g, 'õ')

  contentFormated = contentFormated.replace(/\\'e7/g, 'ç')
  contentFormated = contentFormated.replace(/\\'c7/g, 'Ç')

  return contentFormated
}

function rtcToTextChatIA(content: string) {
  if (!content) return '';

  // Primeiro, preservamos os links e listas
  let contentFormated = content
    // Preserva quebras duplas de linha antes de qualquer processamento
    .replace(/\n\n+/g, '[[DOUBLE_BREAK]]')
    
    // Preserva listas numeradas e pontos
    .replace(/^(\d+\.\s+)/gm, '[[NUM:$1]]')
    .replace(/\n(\d+\.\s+)/g, '[[BREAK]][[NUM:$1]]')
    .replace(/\n\.\s+/g, '[[BREAK]][[DOT]]')
    
    // Preserva links com texto amigável
    .replace(/(https?:\/\/[^\s]+)/g, (match) => {
      if (match.includes('manual.ninegrid.com.br'))
        return '<a href="' + match + '" target="_blank" rel="noopener noreferrer">acesse o manual</a>'
      if (match.includes('ninegrid-pb.atlassian.net'))
        return '<a href="' + match + '" target="_blank" rel="noopener noreferrer">acesse o portal</a>'
      return '<a href="' + match + '" target="_blank" rel="noopener noreferrer">saiba mais</a>'
    })

    // Preserva quebras simples de linha
    .replace(/\n/g, '[[BREAK]]')

  // Processa o texto em parágrafos
  const paragraphs = contentFormated.split('[[DOUBLE_BREAK]]')
  contentFormated = paragraphs.map(paragraph => {
    const lines = paragraph.split('[[BREAK]]')
    let counter = 0
    let isInList = false

    const processedLines = lines.map(line => {
      // Detecta início de lista
      if (line.includes('estas etapas:') || 
          line.includes('Para isso:') || 
          line.includes('siga os passos:')) {
        counter = 0
        isInList = true
        return line + '<br>'
      }

      // Processa itens numerados ou com ponto
      if (line.includes('[[NUM:')) {
        return line.replace(/\[\[NUM:(\d+\.\s+)\]\]/g, '$1')
      }

      if (line.includes('[[DOT]]')) {
        if (isInList) {
          counter++
          return line.replace(/\[\[DOT\]\]/, `${counter}. `)
        }
        return line.replace(/\[\[DOT\]\]/, '. ')
      }

      // Linha em branco - reseta contador de lista
      if (line.trim() === '') {
        isInList = false
      }

      return line
    })

    return processedLines.join('<br>')
  }).join('<br><br>')

  // Aplica formatações RTF e acentuação
  contentFormated = contentFormated
    .replace(/\\par[d]?/g, '<br>')
    .replace(/\\bullet\\tab/gi, '&nbsp;-')
    .replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, '')
     // Acentuação
    .replace(/\\'e3/g, 'ã')
    .replace(/\\'c3/g, 'Ã')
    .replace(/\\'e1/g, 'á')
    .replace(/\\'c1/g, 'Á')
    .replace(/\\'ea/g, 'ê')
    .replace(/\\'ca/g, 'Ê')
    .replace(/\\'e9/g, 'é')
    .replace(/\\'c9/g, 'É')
    .replace(/\\'ed/g, 'í')
    .replace(/\\'f3/g, 'ó')
    .replace(/\\'f5/g, 'õ')
    .replace(/\\'e7/g, 'ç')
    .replace(/\\'c7/g, 'Ç')
    .trim()

  return contentFormated
}

function rtcToTextChatIAOLD(content: string) {
  // Etapa 1 – Normalização e marcação
  let contentFormated = content

    // Preserva quebras de linha e parágrafos
    .replace(/\n\n/g, '[[DOUBLE_BREAK]]')
    .replace(/\n/g, '[[BREAK]]')

    // Marca espaços excessivos
    .replace(/\s{2,}/g, ' ')
    .replace(/^\s+|\s+$/gm, '')

    // Formatações especiais
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')

    // Links com redirecionamento amigável
    .replace(/(https?:\/\/[^\s]+)/g, (match) => {
      if (match.includes('manual.ninegrid.com.br'))
        return '<a href="' + match + '" target="_blank" rel="noopener noreferrer"> acesse o manual </a>';
      if (match.includes('ninegrid-pb.atlassian.net'))
        return '<a href="' + match + '" target="_blank" rel="noopener noreferrer"> acesse o portal </a>';
      return '<a href="' + match + '" target="_blank" rel="noopener noreferrer"> saiba mais </a>';
    })

    // Junta número e texto quebrado em listas numeradas
    .replace(/(\d+)\.\s*[[BREAK]]\s*/g, '[[NUM:$1. ]]');

  // Etapa 2 – Limpeza de RTF
  contentFormated = contentFormated
    .replace(/\\par[d]?/g, '<br>')
    .replace(/\\bullet\\tab/gi, '&nbsp;-')
    .replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, '')
    .trim()

    // Acentuação
    .replace(/\\'e3/g, 'ã')
    .replace(/\\'c3/g, 'Ã')
    .replace(/\\'e1/g, 'á')
    .replace(/\\'c1/g, 'Á')
    .replace(/\\'ea/g, 'ê')
    .replace(/\\'ca/g, 'Ê')
    .replace(/\\'e9/g, 'é')
    .replace(/\\'c9/g, 'É')
    .replace(/\\'ed/g, 'í')
    .replace(/\\'f3/g, 'ó')
    .replace(/\\'f5/g, 'õ')
    .replace(/\\'e7/g, 'ç')
    .replace(/\\'c7/g, 'Ç');

  // Etapa 3 – Processamento linha a linha
  const paragraphs = contentFormated.split('[[DOUBLE_BREAK]]');
  contentFormated = paragraphs.map(paragraph => {
    const lines = paragraph.split('[[BREAK]]');
    let counter = 0;
    let isInList = false;

    const processedLines = lines.map(line => {
      // Detecta início de lista numerada
      if (line.includes('estas etapas:') || line.includes('Para isso:')) {
        counter = 0;
        isInList = true;
        return line;
      }

      // Converte marcador de número
      if (line.includes('[[NUM:')) {
        isInList = true;
        return line.replace(/\[\[NUM:(\d+\.\s+)\]\]/g, '$1');
      }

      // Adiciona quebra antes da bullet se vier após lista numerada
      if (line.trim().startsWith('•')) {
        if (isInList) {
          isInList = false;
          return '<br>' + line;
        }
        return line;
      }

      return line;
    });

    return processedLines.join('<br>');
  }).join('<br><br>');

  // Etapa 4 – Restaura quebras
  contentFormated = contentFormated
    .replace(/\[\[PARA\]\]/g, '<br><br>')
    .replace(/\[\[BR\]\]/g, '<br>');

  return contentFormated;
}



function convertBrazilToUTC(dateTimeString: string) {
  // Parse the input date and time string as if it's in Brazil time (BRT - Brasília Time, UTC-3)
  const brazilTime = new Date(dateTimeString).toUTCString()
  // Return the UTC time string
  return brazilTime
}

function hideCornerCharacters(characters: string, numberCharactersToShow: number) {
  if (characters.length < numberCharactersToShow * 2) {
    return characters
      .split('')
      .map(() => '*')
      .join('')
  } else {
    return characters
      .split('')
      .map((c, index) =>
        index + 1 > numberCharactersToShow && index < characters.length - numberCharactersToShow
          ? '*'
          : c
      )
      .join('')
  }
}

const formatCNPJ = (cnpj: string) => {
  return `${cnpj.substr(0, 2)}.${cnpj.substr(2, 3)}.${cnpj.substr(5, 3)}/${cnpj.substr(
    8,
    4
  )}-${cnpj.substr(12, 2)}`
}

// Função para formatar bytes em unidades legíveis
  const formatBytes = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }

export {
  numberToCpf,
  numberToCpfHidden,
  numberToCnpj,
  numberToCnpjHidden,
  cpfToNumber,
  toDate,
  toDateTime,
  toDateUS,
  dateBRtoDateUS,
  toHour,
  toMoney,
  toMoneyCent,
  toTimeStamp,
  formatPhone,
  formatCpfCnpj,
  removeEspacosEmBranco,
  rtcToText,
  rtcToTextChatIA,
  convertBrazilToUTC,
  hideCornerCharacters,
  formatCNPJ,
  formatBytes,
}
